import { getSessionId } from '@ab-core-functions/tracking';
import type { Query, QueryGetAllPersonalizedSaleSkusArgs } from '@ab-core/graphql/dist';
import { useAuth } from '@ab-core/hooks';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { SHOPPING_LIST_PROMO_AND_CABLE_SNAP_SKUS } from './gql/shoppingListPromoAndCableSnapSkus';

type QueryDataType = Pick<Query, 'getAllPersonalizedSaleSkus'>;
type OutgoingDataType = QueryDataType['getAllPersonalizedSaleSkus'] | undefined;

const onError = getErrorLoggerFunction('getAllPersonalizedSaleSkus');

export const useShoppingListPromoAndCableSnapSkus = () => {
    const { user } = useAuth();

    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType, QueryGetAllPersonalizedSaleSkusArgs>(
        SHOPPING_LIST_PROMO_AND_CABLE_SNAP_SKUS,
        {
            skip: !user,
            variables: { sid: getSessionId() },
            onError
        }
    );

    useEffect(() => {
        if (data?.getAllPersonalizedSaleSkus) {
            setOutgoingData(data.getAllPersonalizedSaleSkus);
        }
    }, [data]);

    return {
        getAllPersonalizedSaleSkus: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
